/**
 * 보스 실시간 판매(live order) 관련 쿼리.
 * live-order/sales, live-order/previous-sales에서 재사용.
 */
import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
  query GetProducts($take: Int!, $cursor: Int, $dateScope: ProductsBySellerDateScope!) {
    productsBySeller(take: $take, cursor: $cursor, dateScope: $dateScope) {
      id
      name
      price
      discountPrice
      userPrice
      img
      quantity
      isEnd
      menus {
        id
        img
        quantity
      }
      order {
        id
        user {
          id
          name
          phone
        }
        isCanceled
        isApproved
        pickUpTime
        identificationCode
        isPickupCompleted
      }
      createdAt
      isToday
      isDeleted
      isSoldout
      currentCount
      currentPurchasedCount
      soldQuantity
      orderItems {
        id
        quantity
        order {
          id
          user {
            id
            name
            phone
          }
          isCanceled
          isApproved
          pickUpTime
          identificationCode
          isPickupCompleted
        }
      }
    }
  }
`;

export const GET_PRODUCT_SALES_DAILY_SUMMARIES = gql`
  query GetProductSalesDailySummaries {
    productSalesDailySummariesBySeller {
      date
      registeredPackCount
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: Int!) {
    deleteProduct(id: $id) {
      id
    }
  }
`;

export const CANCEL_PAYMENT = gql`
  mutation CancelOrder($id: Int!, $reason: String) {
    cancelOrder(id: $id, reason: $reason) {
      ok
      error
    }
  }
`;
